import {
  IDocument,
  IField,
  IFrame,
} from 'app/services/api5-service/api.interface';

import { DocHelper } from 'utils/dochelper';

export interface FrameControlWithValue {
  readonly control: IFrame;
  readonly type: 'frame';
  value: string;
}

/**
 * Map control metadata to typed object with value from doc state
 *
 * @param field - field metadata
 * @param doc - doc
 */
export function getTypeControlsForFrame(
  field: IField,
  doc: IDocument,
): FrameControlWithValue[] {
  return (field.frame ? [field.frame[0]] : []).map(control => {
    return {
      value: DocHelper.getStringValue(control.$name, doc),
      control,
      type: 'frame',
    };
  });
}
